var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15751 7.38911L0.500515 1.73211L1.91451 0.318115L6.86452 5.26812L11.8145 0.318115L13.2285 1.73212L7.57152 7.38911C7.38399 7.57659 7.12968 7.6819 6.86452 7.6819C6.59935 7.6819 6.34504 7.57659 6.15751 7.38911Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowDown);
export default __webpack_public_path__ + "static/media/blackArrowDown.210f3f61876260fd48f16a4313e2c57a.svg";
export { ForwardRef as ReactComponent };